import { Routes } from '@angular/router'

import { MediaLibraryApi } from '@flowx/designer/shared/api/media-library.api'
import { resourcePage } from '@flowx/designer/shared/entities/resource-page.entity'

import { WorkspaceThemesPermissionsResolver } from './workspace.resolvers'

import { MEDIA_LIBRARY_API } from '../../core/dictionary/media-library.dictionary'
import { themeCanActivateGuard, themeCanDeactivateGuard } from '../../theme/guards'

export const WorkspaceEntityRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@flowx/designer/modules/layout/components/main-layout/main-layout.component').then(
        ({ MainLayoutComponent }) => MainLayoutComponent
      ),
    loadChildren: () =>
      import('./workspace-main-layout-routes').then(
        ({ WorkspaceMainLayoutRoutes }) => WorkspaceMainLayoutRoutes
      ),
  },
  // Detail pages have no sidebar, like the theme and font pages.
  {
    path: '',
    loadChildren: () =>
      import('./workspace-entity-details-routes').then(
        ({ WorkspaceEntityDetailsRoutes }) => WorkspaceEntityDetailsRoutes
      ),
  },
  {
    path: 'theme',
    canActivate: [themeCanActivateGuard()],
    providers: [{ provide: MEDIA_LIBRARY_API, useClass: MediaLibraryApi }],
    children: [
      {
        path: ':id',
        data: resourcePage({ type: 'theme', idParam: 'id' }),
        canDeactivate: [themeCanDeactivateGuard],
        resolve: { accessRights: WorkspaceThemesPermissionsResolver },
        loadComponent: () =>
          import('@flowx/designer//modules/theme/theme-page.component').then(
            ({ FlxThemePageComponent }) => FlxThemePageComponent
          ),
      },
    ],
  },
  {
    path: 'cms',
    loadChildren: () => import('@flowx/designer/modules/cms/cms.module').then((m) => m.CmsModule),
  },
]
